import type { GetStreamingInfoByPath200DrmType } from './getStreamingInfoByPath200DrmType';

/**
 * DRM 정보 (있는 경우)
 */
export type GetStreamingInfoByPath200Drm = {
  licenseUrl?: string;
  type?: GetStreamingInfoByPath200DrmType;
};
